<template>
  <div class="PopUpSearch">
    <div class="PopUpSearch_search">
      <div class="search_box">
        <i class="box_icon" />
        <input class="box_input" :placeholder="tips">
      </div>
    </div>
    <div class="PopUpSearch_list">
      <div class="list_box">
        <el-table :data="tableData" height="250" border style="width: 100%">
          <el-table-column prop="date" label="日期" width="180" />
          <el-table-column prop="name" label="姓名" width="180" />
          <el-table-column prop="address" label="地址" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    tips: {
      default: '请搜索'
    }
  },
  data() {
    return {
      tableData: [
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-08',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-06',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.PopUpSearch {
  .PopUpSearch_search {
    height: 36px;
    align-items: center;
    display: flex;
    padding: 0px 10px;
    border: 1px solid #d3d0d0;
    transition: all 0.5s;
    &:hover {
      border-color: black;
    }
    .search_box {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      .box_icon {
        font-style: normal;
        background-image: url("../../../assets/svg/spaui-icon-viewer.svg");
        display: inline-block;
        width: 20px;
        height: 20px;
        background-size: 100%;
        background-repeat: no-repeat;
        flex-shrink: 0;
      }
      .box_input {
        height: 100%;
        padding-left: 18px;
        width: 100%;
      }
    }
  }

  .PopUpSearch_list {
    margin: 46px 0px;
  }
}
</style>
